import { render, staticRenderFns } from "./ghost-bs.vue?vue&type=template&id=b5bccdb8&"
import script from "./ghost-bs.vue?vue&type=script&lang=js&"
export * from "./ghost-bs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5bccdb8')) {
      api.createRecord('b5bccdb8', component.options)
    } else {
      api.reload('b5bccdb8', component.options)
    }
    module.hot.accept("./ghost-bs.vue?vue&type=template&id=b5bccdb8&", function () {
      api.rerender('b5bccdb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/ghost-bs.vue"
export default component.exports